'use client'

import { Fragment } from 'react'
import { Cell, Divider, Radio } from '@vinted/web-ui'

import { PaymentsIdentityDocumentConfigurationModel } from '@marketplace-web/pay-identity/payments-identity-data'

type Props = {
  options: Array<PaymentsIdentityDocumentConfigurationModel>
  selectedConfiguration: PaymentsIdentityDocumentConfigurationModel | null
  onChange: (selectedConfiguration: PaymentsIdentityDocumentConfigurationModel) => void
}

const TypeSelector = ({ options, selectedConfiguration, onChange }: Props) => {
  const handleOptionSelect = (option: PaymentsIdentityDocumentConfigurationModel) => {
    return () => {
      onChange(option)
    }
  }

  const renderDocumentOption = (option: PaymentsIdentityDocumentConfigurationModel) => {
    const isChecked = selectedConfiguration?.type === option.type

    const isDisabled = !selectedConfiguration

    return (
      <Fragment key={option.type}>
        <Cell
          styling={Cell.Styling.Wide}
          title={option.title}
          onClick={handleOptionSelect(option)}
          disabled={isDisabled}
          type={Cell.Type.Navigating}
          suffix={
            <Radio
              name="document_type"
              value={option.type}
              checked={isChecked}
              onChange={() => undefined}
              aria={{
                'aria-labelledby': undefined,
              }}
            />
          }
        />
        <Divider />
      </Fragment>
    )
  }

  return <>{options.map(renderDocumentOption)}</>
}

export default TypeSelector
